<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-personal"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="ferdi-kaza-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <!-- <insurance-prices :insurancePrices="insurancePrices" /> -->
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'

// import insurancePrices from '@/component/categories/InsurancePrices'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import PersonalAccidentInsuranceData from '@/data/category-page-data/PersonalAccidentInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Uygun Ferdi Kaza Poliçesi İçin Teklif Alın ',
    meta: [
      {
        name: 'description',
        content:
          'Ferdi kaza sigortası fiyatlarını karşılaştırarak en doğru ferdi kaza poliçesine sahip olun. Ferdi kaza sigortası ile yarınlarınızı güvence altına alın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'PersonalAccidentInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    // insurancePrices,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.PERSONAL,
      categoryInfo: PersonalAccidentInsuranceData.categoryInfo,
      getPrice: PersonalAccidentInsuranceData.getPrice,
      faqTitle: PersonalAccidentInsuranceData.faqTitle,
      faqTitleDesc: PersonalAccidentInsuranceData.faqTitleDesc,
      questions: PersonalAccidentInsuranceData.questions,
      formData: {
        description: {
          upperText: 'Doğru Kapsam, En İyi Fiyat',
          title: 'Ferdi Kaza Sigortası İçin Teklif Alın',
          bottomText: 'Nakliyat Sigortası Tekliflerini Karşılaştırın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko İle Ferdi Kaza Sigortası Satın Almak Çok Kolay!',
        description:
          'Ferdi kaza sigortası ile kötü sürprizlere karşı güvence altında olun.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Ani ve Harici Olaylar',
            desc:
              'Günlük hayatta başınıza gelebilecek ani ve harici olaylar sebebiyle uğrayabileceğiniz bedensel zararlar teminat altındadır.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Geniş Asistans Hizmetleri',
            desc:
              'Kaza sonucu ölüm, sürekli sakatlık, tedavi masrafları ve gündelik tazminat teminatları ile birlikte asistans hizmetleri tek bir poliçeyle temin edilebilmektedir.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'En Uygun Poliçeyi Anında Seçin',
            desc:
              'Çok sayıda mevcut fiyat teklifi arasından ihtiyaçlarınıza ve bütçenize en uygun olanı seçerek oluşabilecek ani riskleri önleyin.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Seçtiğiniz Poliçeyi Online Satın Alın',
            desc:
              'Kolay ödeme avantajı ile kredi kartına özel taksit imkânından yararlanın, poliçenizi hemen alın.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Ferdi Kaza Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
